export default {
  buttons: {
    save: 'Gem',
  },
  error_messages: {
    product_unavailable: 'Udsolgt!',
  },
};
